import { Icono } from '../../componentes/Icono';
import type { Anillo, Proximo } from './proximo';

/**
 * «Lo próximo», en grande (7.1; RV Grafico + RV Anillo, 8 + 4): las barras por hora (la hora en curso en rojo) y, al
 * lado, el anillo hacia su tope (entradas vendidas sobre el aforo, llegadas sobre las citas de hoy). Sin nada todavía,
 * la frase de vacío. «Ver …» abre la entrada del menú del módulo, si la persona la tiene.
 */
export function LoProximo({ proximo: p, ruta, navegar }: { proximo: Proximo; ruta: string | null; navegar: (ruta: string) => void }) {
    const maximo = Math.max(1, ...p.barras.map((b) => b.valor));
    const hay = p.barras.some((b) => b.valor > 0);
    return (
        <section className="rv-inicio__proximo" aria-label={`Lo próximo: ${p.titulo}`}>
            <div className="rv-inicio__caja">
                <div className="rv-inicio__caja-cab">
                    <strong>{p.titulo}</strong>
                    {ruta !== null && (
                        <button type="button" className="rv-inicio__enlace" onClick={() => { navegar(ruta); }}>
                            {p.verMas.texto}
                            <Icono nombre="chevron-right" />
                        </button>
                    )}
                </div>
                {!hay ? (
                    <>
                        <span className="rv-inicio__grande">{p.vacio}</span>
                        <p className="rv-inicio__nota">{p.porque}</p>
                    </>
                ) : (
                    <>
                        <span className="rv-inicio__grande">
                            {new Intl.NumberFormat('es-ES').format(p.cifra)}
                            <small>{p.unidad}</small>
                        </span>
                        <p className="rv-inicio__nota">{p.linea}</p>
                        <div className="rv-inicio__barras" role="img" aria-label={`${p.titulo} por hora: ${p.barras.map((b) => `${b.detalle.toLowerCase()}, ${String(b.valor)}`).join('; ')}`}>
                            {p.barras.map((b, i) => (
                                <span key={b.etiqueta} className={i === p.ahora ? 'rv-inicio__barra-ahora' : undefined} title={`${b.detalle}: ${String(b.valor)} ${p.unidad}`}>
                                    <i style={{ height: `${String((b.valor / maximo) * 100)}%` }} />
                                </span>
                            ))}
                        </div>
                        <div className="rv-inicio__horas" aria-hidden="true">
                            {p.barras.map((b, i) => (
                                <span key={b.etiqueta} className={i === p.ahora ? 'rv-inicio__barra-ahora' : undefined}>
                                    {b.etiqueta}
                                </span>
                            ))}
                        </div>
                    </>
                )}
            </div>
            {p.anillo !== null && <AnilloHoy anillo={p.anillo} />}
        </section>
    );
}

function AnilloHoy({ anillo: a }: { anillo: Anillo }) {
    const r = 52;
    const largo = 2 * Math.PI * r;
    const parte = a.tope > 0 ? Math.min(1, a.valor / a.tope) : 0;
    return (
        <div className="rv-inicio__caja rv-inicio__anillo" aria-label={`${a.titulo}: ${String(a.valor)} de ${String(a.tope)}. ${a.nota}`} role="group">
            <strong>{a.titulo}</strong>
            <span>{a.sub}</span>
            <svg viewBox="0 0 128 128" aria-hidden="true">
                <circle className="rv-inicio__anillo-fondo" cx="64" cy="64" r={r} />
                <circle className="rv-inicio__anillo-arco" cx="64" cy="64" r={r} strokeDasharray={`${String(largo * parte)} ${String(largo)}`} transform="rotate(-90 64 64)" />
                <text x="64" y="70" textAnchor="middle" fontSize="22" fontWeight="800">{`${String(Math.round(parte * 100))} %`}</text>
            </svg>
            <strong>{a.etiqueta}</strong>
            <span>{`${String(a.valor)} de ${String(a.tope)}`}</span>
            <span>{a.nota}</span>
        </div>
    );
}
